export default "__VITE_ASSET__b14305d1__"